<template>
  <main data-int="browse" class="browse-container">
    <hero/>
    <slot name="breadcrumbs">
      <breadcrumb />
    </slot>
    <slot name="content">
      <router-view
        :key="`browse-${$i18n.locale}`"
      />
    </slot>
  </main>
</template>

<script>
import Hero from '@/components/common/Hero';
import Breadcrumb from './Breadcrumb';

export default {
  name: 'BrowseHeader',
  components: {
    Breadcrumb,
    Hero
  }
}
</script>

<style scoped>
.browse-container {
  flex: 1;
  display: flex;
  flex-flow: column;
}
</style>
